export const ASSETS_BASE_URL =
  "https://storage.googleapis.com/yardzen-public-assets";
